import React from "react";
import ReactPlayer from "react-player";
import leadingHourse from "../assets/images/svg/leading_hourse.svg";
import circleImg from "../assets/images/svg/circle_img.svg";

const Gold = () => {
  return (
    <>
      <div className="gold_section d-flex align-items-center position-relative  pt-5">
        <div className="container">
          <div className="row ">
            <div className="col-lg-5 mb-4 mb-lg-0">
              <div className="text-center text-lg-start">
                <h3
                  className="font-2xl font-normal ff_josfin color-light-black mb-2 pb-1"
                  data-aos="fade-right"
                  data-aos-duration="800">
                  THE GOLD STANDARD
                </h3>
                <p
                  data-aos="fade-right"
                  data-aos-duration="800"
                  data-aos-delay="300"
                  className="opacity-07 ff_lato fw-normal font-sm color-light-black pe-lg-3 pe-xl-5 me-xxl-5">
                  We aim to set a high bar in the industrial cybersecurity space
                  where we bring the best workforce and develop The Top Of The
                  Line Next-Gen Products And Services that go with our own
                  individually crafted in-house Cybersecurity programs for each
                  industrial sector's OT/IoT environment.
                </p>
              </div>
            </div>
            <div className="col-lg-7 gold_video_static position_lg_absolute end-0 top-0">
              <div className=" text-center">
                <ReactPlayer
                  className="object_fit_cover gold_section_video"
                  url="https://vz-e28eac45-f0a.b-cdn.net/5416407a-332f-496c-97e4-016cb5a219d8/playlist.m3u8"
                  width="100%"
                  playing={true}
                  loop={true}
                  muted={true}
                  height="100%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gold;
